export default "__VITE_ASSET__d911348c__"